import { gsap } from 'gsap' ;
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { CSSPlugin } from 'gsap/CSSPlugin';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

export default {
  init() {
    // JavaScript to be fired on the about us page
    console.log('arranca el entradas landing');

    $('#quitar-mute').on('click', function (){
      if( $('video').prop('muted', true) )
      {
        $('video').prop('muted', false);
        $('#quitar-mute').css('display','none');
        $('#mute-video').css('display','block');
      }
    });

    $('#mute-video').on('click', function (){
      $('video').prop('muted', true);
      $('#quitar-mute').css('display','block');
      $('#mute-video').css('display','none');
    });

    gsap.registerPlugin(ScrollTrigger, CSSPlugin, ScrollToPlugin);
   //let altura = $('.btn-comprar').position();
    const tl3 = gsap.timeline({
      scrollTrigger: {
        trigger: '#videoPrincipalHome',
        start: 'top center',
        end: '75% 90%',
        scrub: true,
        markers: false,
      },
    });
    tl3.to('.btn-comprar',{duration: 1, css: { position: 'fixed', zIndex: 9999}}),
    tl3.to('.btn-comprar',{duration: 1, css: { right: '2vw'}}),
    tl3.to('.btn-comprar',{duration: 3, css: { top: '5vh'}}),
    tl3.to('.btn-comprar',{duration: 3, css: { maxWidth: '225px'}});
    /*let altura = $('.btn-comprar').position();
    console.log(altura.top);
    $(window).on('scroll', function(){
        console.log($('.btn-comprar').position());
     
        if ($(window).scrollTop() > altura.top) {
          $('.btn-comprar').addClass('fixed-botton');
        

    
        } else {
          $('.btn-comprar').removeClass('fixed-botton');
        }
     
  });*/

   
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/template-entradaslanding.js